import React from 'react';
import { TextInput, TextArea, CardList, StringList, SectionHeader, Field } from './Fields';
import ImageUpload from './ImageUpload';

const COLORS = ['blue', 'emerald', 'violet'];
const ICONS = ['dashboard', 'location_on', 'assignment', 'settings', 'analytics', 'people', 'map', 'description'];

const PlataformaEditor = ({ data, onChange }) => {
  const set = (key, val) => onChange({ ...data, [key]: val });
  const setNested = (key, subkey, val) => onChange({ ...data, [key]: { ...data[key], [subkey]: val } });

  const hero = data.hero || {};
  const sei = data.sei || {};
  const onboarding = data.onboarding || {};
  const faq = data.faq || {};
  const modulos = data.modulos || [];

  return (
    <div className="space-y-10">

      {/* Hero */}
      <div>
        <SectionHeader title="Hero da Página" />
        <TextInput label="Badge (etiqueta)" value={hero.badge} onChange={v => setNested('hero', 'badge', v)} placeholder="Documentação" />
        <TextInput label="Título principal" value={hero.heading} onChange={v => setNested('hero', 'heading', v)} />
        <TextArea label="Subtítulo" value={hero.subheading} onChange={v => setNested('hero', 'subheading', v)} />
      </div>

      {/* Módulos */}
      <div>
        <SectionHeader title="Módulos" />
        <CardList
          label="Módulos da plataforma"
          value={modulos}
          onChange={v => set('modulos', v)}
          emptyCard={{ id: '', icon: 'dashboard', color: 'blue', title: '', description: '', features: [], image_url: '' }}
          renderCard={(item, i, update) => (
            <div className="space-y-3">
              <div className="grid grid-cols-2 gap-3">
                <TextInput label="Título" value={item.title} onChange={v => update({ title: v })} />
                <Field label="Ícone (Material Icons)">
                  <div className="flex gap-2 flex-wrap">
                    {ICONS.map(ic => (
                      <button
                        key={ic}
                        onClick={() => update({ icon: ic })}
                        title={ic}
                        className={`p-2 rounded-lg border-2 transition-all ${item.icon === ic ? 'border-blue-500 bg-blue-50' : 'border-transparent bg-gray-100 hover:bg-gray-200'}`}
                      >
                        <span className="material-icons text-base text-gray-700">{ic}</span>
                      </button>
                    ))}
                  </div>
                </Field>
              </div>
              <TextArea label="Descrição longa" value={item.description} onChange={v => update({ description: v })} rows={3} />
              <StringList
                label="Funcionalidades"
                value={item.features}
                onChange={v => update({ features: v })}
                placeholder="Ex: Controle de processos"
              />
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">Cor do módulo</label>
                <div className="flex gap-2">
                  {COLORS.map(c => (
                    <button
                      key={c}
                      onClick={() => update({ color: c })}
                      className={`px-3 py-1 rounded-full text-xs font-semibold border-2 transition-all bg-${c}-100 text-${c}-700 ${item.color === c ? 'border-blue-500 scale-110' : 'border-transparent opacity-60'}`}
                    >
                      {c}
                    </button>
                  ))}
                </div>
              </div>
              <ImageUpload
                label="Screenshot do módulo"
                value={item.image_url}
                onChange={v => update({ image_url: v })}
              />
            </div>
          )}
        />
      </div>

      {/* SEI */}
      <div>
        <SectionHeader title="Integração SEI!" />
        <TextInput label="Título" value={sei.heading} onChange={v => setNested('sei', 'heading', v)} />
        <TextInput label="Subtítulo" value={sei.subheading} onChange={v => setNested('sei', 'subheading', v)} />
        <TextArea label="Descrição completa" value={sei.description} onChange={v => setNested('sei', 'description', v)} rows={4} />
        <StringList
          label="Benefícios da integração"
          value={sei.benefits || []}
          onChange={v => setNested('sei', 'benefits', v)}
          placeholder="Ex: Sincronização automática de processos"
        />
        <ImageUpload
          label="Imagem da integração"
          value={sei.image_url}
          onChange={v => setNested('sei', 'image_url', v)}
        />
      </div>

      {/* Onboarding */}
      <div>
        <SectionHeader title="Como Começar (Onboarding)" />
        <TextInput label="Título" value={onboarding.heading} onChange={v => setNested('onboarding', 'heading', v)} />
        <TextInput label="Subtítulo" value={onboarding.subheading} onChange={v => setNested('onboarding', 'subheading', v)} />
        <CardList
          label="Passos"
          value={onboarding.steps || []}
          onChange={v => setNested('onboarding', 'steps', v)}
          emptyCard={{ title: '', description: '' }}
          renderCard={(item, i, update) => (
            <div className="space-y-2">
              <TextInput label="Título do passo" value={item.title} onChange={v => update({ title: v })} />
              <TextArea label="Descrição" value={item.description} onChange={v => update({ description: v })} rows={2} />
            </div>
          )}
        />
      </div>

      {/* FAQ */}
      <div>
        <SectionHeader title="FAQ" />
        <TextInput label="Título" value={faq.heading} onChange={v => setNested('faq', 'heading', v)} />
        <CardList
          label="Perguntas e Respostas"
          value={faq.items || []}
          onChange={v => setNested('faq', 'items', v)}
          emptyCard={{ question: '', answer: '' }}
          renderCard={(item, i, update) => (
            <div className="space-y-2">
              <TextInput label="Pergunta" value={item.question} onChange={v => update({ question: v })} />
              <TextArea label="Resposta" value={item.answer} onChange={v => update({ answer: v })} rows={3} />
            </div>
          )}
        />
      </div>

    </div>
  );
};

export default PlataformaEditor;
